(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cnm-catalogue"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.cnm-catalogue').forEach(catalogue=>{
const links=[...catalogue.querySelectorAll('.cnm-catalogue__nav a')];
const sections=[...catalogue.querySelectorAll('.cnm-catalogue__section')];
const update=()=>{let current=sections[0];for(const section of sections){if(section.getBoundingClientRect().top<160)current=section;}links.forEach(link=>{if(link.hash==='#'+current?.id)link.setAttribute('aria-current','true');else link.removeAttribute('aria-current');});};
let scheduled=false;window.addEventListener('scroll',()=>{if(!scheduled){scheduled=true;requestAnimationFrame(()=>{update();scheduled=false;});}},{passive:true});update();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cnm-gender-intro"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cnm-gender-reveal')) {
  customElements.define('cnm-gender-reveal', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      this.stop();
      this.paused = false;
      this.visible = false;
      const button = this.querySelector('.cnm-gender-reveal__toggle');
      const status = this.querySelector('.cnm-gender-reveal__status');
      if (!button || !status) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.reveal = () => {
        const revealed = this.dataset.revealed !== 'true';
        this.dataset.revealed = String(revealed);
        status.textContent = revealed ? window.cnmText("… et une jolie nouvelle à partager.") : window.cnmText("Un secret bien gardé…");
        if (reduce) button.textContent = revealed ? window.cnmText("Revoir le gâteau entier") : window.cnmText("Voir l’intérieur du gâteau");
      };
      this.start = () => {
        this.stop();
        if (!reduce && !this.paused && this.visible && !document.hidden) this.timer = setInterval(this.reveal, 2000);
      };
      if (reduce) button.textContent = window.cnmText("Voir l’intérieur du gâteau");
      button.addEventListener('click', () => {
        if (reduce) { this.reveal(); return; }
        this.paused = !this.paused;
        button.setAttribute('aria-pressed', String(this.paused));
        button.textContent = this.paused ? window.cnmText("Reprendre la révélation") : window.cnmText("Mettre en pause");
        this.start();
      }, { signal: this.events.signal });
      document.addEventListener('visibilitychange', this.start, { signal: this.events.signal });
      this.observer?.disconnect();
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.start();
      }, { threshold: .15 });
      this.observer.observe(this);
    }
    stop() { clearInterval(this.timer); }
    disconnectedCallback() { this.stop(); this.observer?.disconnect(); this.events?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
const initCnmVideos = () => {
  document.querySelectorAll('slideshow-component').forEach(carousel => {
    if (carousel.dataset.cnmVideoReady || !carousel.querySelector('.cnm-slide-video')) return;
    carousel.dataset.cnmVideoReady = 'true';
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const videos = carousel.querySelectorAll('.cnm-slide-video');
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const video = entry.target;
        if (entry.isIntersecting && !document.hidden && !reduced.matches) {
          video.muted = true;
          video.defaultPlaybackRate = 1.1;
          video.playbackRate = 1.1;
          video.play().catch(() => { video.controls = true; });
        } else { video.pause(); }
      });
    }, { threshold: 0.6 });
    videos.forEach(video => {
      observer.observe(video);
      if (reduced.matches) video.controls = true;
    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) videos.forEach(video => video.pause());
      else videos.forEach(video => { observer.unobserve(video); observer.observe(video); });
    });
    reduced.addEventListener('change', () => videos.forEach(video => {
      video.controls = reduced.matches;
      observer.unobserve(video);
      observer.observe(video);
    }));
  });
};
initCnmVideos();
document.addEventListener('shopify:section:load', initCnmVideos);

  } catch(e) { console.error(e); }
})();
})();
